import React, { useEffect, useRef, useState } from "react";

const OffCanvas = ({ offCanvas, showCanvas, data }) => {
  const [infoData, setInfoData] = useState({});
  const offcanvasref = useRef(null);

  useEffect(() => {
    setInfoData(data);
  }, [data]);

  console.log(infoData, 4534543332);

  useEffect(() => {
    document.addEventListener("mousedown", (e) => {
      if (offcanvasref.current && !offcanvasref.current.contains(e.target)) {
        offCanvas();
      }
    });

    return () => {
      document.removeEventListener("mousedown", () => {});
    };
  }, []);

  const getFormatData = (data) => {
    return (
      <div className="add-info">
        {data.hasOwnProperty("current_page") && (
          <div className="add-info-data">
            <span className="info-one">
              {"current_page".split("_").join(" ")}
            </span>
            <span className="info-two">
              {data["current_page"] ? (
                <a href={`${data["current_page"]}`} target="_blank">
                  {data["current_page"].length > 28
                    ? data["current_page"].slice(0, 28) + "..."
                    : data["current_page"]}
                </a>
              ) : (
                "--"
              )}
            </span>
          </div>
        )}
        {data.hasOwnProperty("chat_status") && (
          <div className="add-info-data">
            <span className="info-one">
              {"chat_status".split("_").join(" ")}
            </span>
            <span className="info-two">{data["chat_status"] || "--"}</span>
          </div>
        )}
        {(data.hasOwnProperty("chat_status") ||
          data.hasOwnProperty("current_page")) && <hr />}
        {data.hasOwnProperty("campaign_source") && (
          <div className="add-info-data">
            <span className="info-one">
              {"campaign_source".split("_").join(" ")}
            </span>
            <span className="info-two">{data["campaign_source"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("campaign_name") && (
          <div className="add-info-data">
            <span className="info-one">
              {"campaign_name".split("_").join(" ")}
            </span>
            <span className="info-two">{data["campaign_name"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("campaign_term") && (
          <div className="add-info-data">
            <span className="info-one">
              {"campaign_term".split("_").join(" ")}
            </span>
            <span className="info-two">{data["campaign_term"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("campaign_medium") && (
          <div className="add-info-data">
            <span className="info-one">
              {"campaign_medium".split("_").join(" ")}
            </span>
            <span className="info-two">{data["campaign_medium"] || "--"}</span>
          </div>
        )}
        {(data.hasOwnProperty("campaign_medium") ||
          data.hasOwnProperty("campaign_term") ||
          data.hasOwnProperty("campaign_name") ||
          data.hasOwnProperty("campaign_source")) && <hr />}
        {data.hasOwnProperty("city") && (
          <div className="add-info-data">
            <span className="info-one">{"city".split("_").join(" ")}</span>
            <span className="info-two">{data["city"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("state") && (
          <div className="add-info-data">
            <span className="info-one">{"state".split("_").join(" ")}</span>
            <span className="info-two">{data["state"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("country") && (
          <div className="add-info-data">
            <span className="info-one">{"country".split("_").join(" ")}</span>
            <span className="info-two">{data["country"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("time_zone") && (
          <div className="add-info-data">
            <span className="info-one">{"time_zone".split("_").join(" ")}</span>
            <span className="info-two">{data["time_zone"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("longitude") && (
          <div className="add-info-data">
            <span className="info-one">{"longitude".split("_").join(" ")}</span>
            <span className="info-two">{data["longitude"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("latitude") && (
          <div className="add-info-data">
            <span className="info-one">{"latitude".split("_").join(" ")}</span>
            <span className="info-two">{data["latitude"] || "--"}</span>
          </div>
        )}
        {(data.hasOwnProperty("latitude") ||
          data.hasOwnProperty("longitude") ||
          data.hasOwnProperty("time_zone") ||
          data.hasOwnProperty("country") ||
          data.hasOwnProperty("state")) && <hr />}
        {data.hasOwnProperty("operating_system") && (
          <div className="add-info-data">
            <span className="info-one">
              {"operating_system".split("_").join(" ")}
            </span>
            <span className="info-two">{data["operating_system"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("browser_type") && (
          <div className="add-info-data">
            <span className="info-one">
              {"browser_type".split("_").join(" ")}
            </span>
            <span className="info-two">{data["browser_type"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("user_agent") && (
          <div className="add-info-data">
            <span className="info-one">
              {"user_agent".split("_").join(" ")}
            </span>
            <span className="info-two">{data["user_agent"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("browser_version") && (
          <div className="add-info-data">
            <span className="info-one">
              {"browser_version".split("_").join(" ")}
            </span>
            <span className="info-two">{data["browser_version"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("referer") && (
          <div className="add-info-data">
            <span className="info-one">{"referer".split("_").join(" ")}</span>
            <span className="info-two">
              {data["referer"] ? (
                <a href={data["referer"]} target="_blank">
                  {data["referer"].length > 28
                    ? data["referer"].slice(0, 28) + "..."
                    : data["referer"]}
                </a>
              ) : (
                "--"
              )}
            </span>
          </div>
        )}
        {data.hasOwnProperty("landing_page") && (
          <div className="add-info-data">
            <span className="info-one">
              {"landing_page".split("_").join(" ")}
            </span>
            <span className="info-two">
              {data["landing_page"] ? (
                <a href={`${data["landing_page"]}`} target="_blank">
                  {data["landing_page"].length > 28
                    ? data["landing_page"].slice(0, 28) + "..."
                    : data["landing_page"]}
                </a>
              ) : (
                "--"
              )}
            </span>
          </div>
        )}
        {data.hasOwnProperty("visitor_ip") && (
          <div className="add-info-data">
            <span className="info-one">
              {"visitor_ip".split("_").join(" ")}
            </span>
            <span className="info-two">{data["visitor_ip"] || "--"}</span>
          </div>
        )}
        {(data.hasOwnProperty("visitor_ip") ||
          data.hasOwnProperty("referer") ||
          data.hasOwnProperty("browser_version") ||
          data.hasOwnProperty("user_agent") ||
          data.hasOwnProperty("browser_type") ||
          data.hasOwnProperty("operating_system")) && <hr />}
        {data.hasOwnProperty("score") && (
          <div className="add-info-data">
            <span className="info-one">{"score".split("_").join(" ")}</span>
            <span className="info-two">{data["score"] || "--"}</span>
          </div>
        )}
        {data.hasOwnProperty("probability") && (
          <div className="add-info-data">
            <span className="info-one">
              {"probability".split("_").join(" ")}
            </span>
            <span className="info-two">{data["probability"] || "--"}</span>
          </div>
        )}
      </div>
    );
  };
  return (
    //     <a class="btn btn-primary" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">
    //     Link with href
    //   </a>
    //   <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
    //     Button with data-bs-target
    //   </button>

    <div
      class="offcanvas offcanvas-start"
      tabindex="-1"
      id="offcanvasExample"
      aria-labelledby="offcanvasExampleLabel"
      style={
        showCanvas
          ? { transform: "translateX(-18%)" }
          : { transform: "translateX(100%)" }
      }
      ref={offcanvasref}
    >
      <div className="close-times">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="#000"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6"
          width="22px"
          onClick={offCanvas}
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18 18 6M6 6l12 12"
          />
        </svg>
      </div>
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasExampleLabel">
          Info
        </h5>
      </div>
      <div class="offcanvas-body">{getFormatData(infoData)}</div>
    </div>
  );
};

export default OffCanvas;



// WEBPACK FOOTER //
// ./src/components/chat/OffCanvas.js